import React, { useContext } from "react";

import type { AppModel } from "../../types/AppModel";

const AppModelContext = React.createContext<AppModel>({
  payOnDelivery: {
    paymentMethod: "",
  },
  zeroValueOrder: {
    userNotification: "",
  },
  loyalty: {
    learnMoreUrl: "",
    currencyLocation: "",
    orderConfirmationLoyaltyUrl: "",
    redemptionTabSymbol: "",
    showMgm: false,
    showReminderDialog: false,
    reminderDialogTitle: "",
    reminderDialogSubtitle: "",
    reminderDialogText: "",
    reminderDialogSecondaryButtonText: "",
    reminderDialogSecondaryButtonLink: "",
    reminderDialogSKUs: "",
  },
  failedPaymentFlow: {
    title: "",
    message: "",
    retryPaymentButtonLabel: "",
  },
  contactConfig: {
    differentRecipientDisabled: false,
    populatedPhoneInput: false,
  },
  discountDisclaimer: {
    enabled: false,
    disclaimerMessage: "",
    warningMessage: "",
  },
  ageVerificationPopup: {
    description: "",
    successMessage: "",
    popupMode: false,
  },
  ageVerificationMethodImages: {
    international_passport: "",
    passport: "",
    driving_license: "",
  },
  consentReminderPopup: {
    consentReminderPopupEnabled: false,
    maximumOccurancesPerYear: 0,
    consentExpirationLimit: 0,
    popUpDelay: 0,
    offerConsentName: "",
    productInformationConsentName: "",
    ploomClubConsentName: "",
    mainImage: "",
    imageAltText: "",
    subtitle: "",
    mainQuestion: "",
    description: "",
    yesButtonText: "",
    noButtonText: "",
    yesRedirectUrl: "",
  },
});

export const AppModelProvider = ({ children, model }: { children: React.ReactNode; model: AppModel }) => {
  return <AppModelContext.Provider value={model}>{children}</AppModelContext.Provider>;
};

export const useAppModel = (): AppModel => {
  return useContext(AppModelContext);
};
